import { Pipe, PipeTransform } from '@angular/core';
import {Mascaras} from '../masks/mascaras';

@Pipe({
    name: 'real'
})

export class RealPipe implements PipeTransform {
    transform(value: any, args: any[]): any {
        if (value != undefined && value != null) {
            return Mascaras.decimalToStringBR(value.toString());
        }
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/core/pipes/real.pipe.ts
 **/